import ActivityPanel from '@tencent/tpm-meeting-active/lib/ActivityPanel';
import '@tencent/tpm-meeting-active/lib/ActivityPanel/style';
import ContentTip from '@tencent/tpm-meeting-active/lib/ContentTip';
import '@tencent/tpm-meeting-active/lib/ContentTip/style';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import useEventDetailHooks from '@component/EventDetailNav/hooks/useEventDetail';
import useProgressChange from 'src/hooks/useProccessChange';
import SingleUpload from 'src/components/FormCover/SingleImageUpload';
import React, { FC, useMemo, useCallback, useState, useEffect } from 'react';
import { ACTION, useStore } from '@utils/event-store/useEventData';
import { useRouter } from 'next/router';
import { message } from '@tencent/tea-component';
import { Activity } from 'src/model/type';
import UpdateCoverImage from '@quickService/UpdateCoverImage';

type ActivityCover = Required<Pick<Activity, 'cover_cos_id' | 'cover_url'>>;

const DetailCard: FC = () => {
  const { eventInfo, dispatch } = useStore();
  const { status } = useEventDetailHooks(eventInfo);
  const { validateStatus } = useProgressChange();

  const timeData = useMemo(() => {
    const d = dayjs((eventInfo?.start_time || 0) * 1000);
    return [d.locale('zh-cn').format('ddd'), d.format('M月DD号'), d.format('HH:mm')];
  }, [eventInfo]);

  const [coverInfo, setCoverInfo] = useState<ActivityCover>({
    cover_cos_id: '',
    cover_url: '',
  });

  // 保存基本信息后，更新这里
  useEffect(() => {
    if (eventInfo.cover_cos_id) {
      setCoverInfo({
        cover_cos_id: eventInfo.cover_cos_id,
        cover_url: eventInfo.cover_url || '',
      });
    }
  }, [eventInfo]);

  const onUploadSuccess = useCallback(
    (v) => {
      if (v) {
        const { cosId, url } = v;
        setCoverInfo({
          cover_cos_id: cosId,
          cover_url: url,
        });
        UpdateCoverImage({
          event_id: eventInfo.event_id as string,
          cover_image: cosId,
        }).then((res) => {
          if (res.code === 0) {
            message.success({
              content: '封面更新成功',
            });
            validateStatus(); // 更新全局 eventInfo
            // 更新一下 coverInfo
            dispatch({
              type: ACTION.UPDATECOVER,
              data: {
                cover_cos_id: cosId,
                cover_url: url,
              },
            });
          }
        });
      }
    },
    [eventInfo],
  );

  return (
    <ActivityPanel
      title={<ContentTip line={2}>{eventInfo?.title}</ContentTip>}
      data={timeData}
      coverDom={
        <SingleUpload
          size="mini"
          aspectRatio={21 / 11}
          coverInfo={{
            cutted: coverInfo.cover_url,
            cuttedCosId: coverInfo.cover_cos_id,
            origin: coverInfo.cover_url,
            originCosId: coverInfo.cover_cos_id,
            position: '',
          }}
          onUploadComplete={onUploadSuccess}
        />
      }
      status={status}
      className={status.className}
    />
  );
};

export const DisablePage = () => {
  const { eventInfo } = useStore();
  const router = useRouter();

  const disablePage = useMemo(
    () =>
      router.pathname !== '/event/[eventid]' &&
      (eventInfo?.status === 2 || eventInfo?.status === 4),
    [router.pathname, eventInfo?.status],
  );

  const onClick = useCallback(() => {
    message.warning({ content: '活动发布中，请耐心等待审核，或取消发布后修改' });
  }, []);

  return disablePage ? <div className="page-event-disable-page" onClick={onClick} /> : null;
};

export default DetailCard;
